import { useNavigate } from "react-router-dom";
import { Activity, ArrowRight, Settings2 } from "lucide-react";
import { AppLayout, PageContent } from "@/components/layout/AppLayout";
import { useAccount } from "@/contexts/AccountContext";

const ALL_SECTIONS = [
  {
    id: "monitoring",
    adminOnly: false,
    icon: Activity,
    label: "Monitoring",
    description: "SOC analyst view — real-time event detection, log analysis",
    href: "/monitoring",
  },
  {
    id: "management",
    adminOnly: true,
    icon: Settings2,
    label: "Management",
    description: "Configure monitoring dashboards and manage SOC platform settings.",
    href: "/admin/dashboards",
  },
];

export default function HomePage() {
  const navigate = useNavigate();
  const { isAdmin, firstName } = useAccount();

  const sections = ALL_SECTIONS.filter((s) => !s.adminOnly || isAdmin);

  return (
    <AppLayout>
      <PageContent>
        <div className="flex flex-col items-center py-16 px-4">
          {/* Heading */}
          <div className="mb-12 text-center">
            <h1 className="text-[28px] font-semibold text-primary tracking-tight leading-tight">
              {firstName ? `Hi, ${firstName}` : "Security Operations Center"}
            </h1>
            {firstName && <p className="text-sm text-muted mt-2">Security Operations Center</p>}
          </div>

          {/* Section cards */}
          <div
            className={`w-full gap-5 grid grid-cols-1 ${
              sections.length === 1 ? "max-w-xs sm:max-w-sm" : "max-w-4xl sm:grid-cols-2"
            }`}
          >
            {sections.map((section) => {
              const Icon = section.icon;
              return (
                <button
                  key={section.id}
                  onClick={() => navigate(section.href)}
                  className="group text-left rounded-xl border border-border/75 bg-surface transition-all duration-150 flex flex-col hover:border-brand-cyan/30 cursor-pointer"
                >
                  <div className="p-7 flex-1 min-h-36">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="inline-flex items-center justify-center h-12 w-12 rounded-xl bg-surface-elevated/55 border border-border/80 shrink-0 transition-colors group-hover:border-brand-cyan/25">
                        <Icon className="h-6 w-6 text-brand-cyan" strokeWidth={1.6} />
                      </div>
                      <p className="text-[17px] font-semibold text-primary leading-snug">
                        {section.label}
                      </p>
                    </div>
                    <p className="text-[13px] text-secondary leading-relaxed">
                      {section.description}
                    </p>
                  </div>
                  <div className="flex items-center justify-end px-7 py-3.5 border-t border-border">
                    <span className="flex items-center gap-1.5 text-[12px] text-muted group-hover:text-primary transition-colors">
                      Open
                      <ArrowRight
                        className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition-transform duration-150"
                        strokeWidth={2}
                      />
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </PageContent>
    </AppLayout>
  );
}
